import React, { Component } from 'react';
import mapTracking,{clearMapTracking,zoomTo,getJSONCar,setMapToggle,setTrafficToggle,updateMapSize
    ,setCurrentStatus,setUpdatePOI,setVisiblePOILayer,setVisiblePOIName, getPOI,zoomToExtent,switchBaseMap,clearSelectCar} from './js/MapTracking';
import PropTypes from 'prop-types';


import TarckSummary from '../TarckSummary/TarckSummary'
import $ from 'jquery';
import MapBalloon from '../MapBalloon/Mapballoon';
class MapTracking extends Component {
    constructor(props) {
		super(props);

		this.state = {
            mapTogglePath:'images/pin/type_sat.png',
            trafficTogglePath:'images/pin/traffic.png'
		};
    }
    componentDidMount(){
        console.log("MapTracking componentDidMount  porp.t" ,this.porp);
        mapTracking(this.props);
        //$("#mapTracking").css("height", $(window).height() - 190);
        $("#mapTracking").css("height", $(window).height() - 80);
        updateMapSize();
    }
    componentWillUnmount(){
        console.log("MapTracking componentWillUnmount");
        this.clearComp();
    }
    updateMapSize(){
        updateMapSize();
    }
    clearComp(){
        clearMapTracking();
    }
    zoomTo(index,lat,lng){  
        zoomTo(index,lat,lng);
    }
    searchCarTrack(tags,isGroupOrder){
        console.log("searchCarTrack")
        getJSONCar(this.props,tags,isGroupOrder,true);
    }
    searchIsGroup(isGroupOrder){
        getJSONCar(this.props,undefined,isGroupOrder,false);
    }
    handleSetMapToggle(){
        let p = setMapToggle(this.state.mapTogglePath);
        this.setState({mapTogglePath : p});
    }
    handleSetTrafficToggle(){
        let p = setTrafficToggle(this.state.trafficTogglePath);
        this.setState({trafficTogglePath : p});
    }

    handleFullScreenToggle(){
        if( $("#monitorLeftPanel").css('display') == "none"){
            // $("#monitorDealerListMini").css('display',"block");
            // $("#monitorDealerList").css('display',"block");
            $("#monitorLeftPanel").show();
            $(".map-full").removeClass("map-full").addClass("map");
            $(".btn-map-extent").removeClass("fa-rotate-180");
        }else{
            // $("#monitorDealerListMini").css('display',"none");
            // $("#monitorDealerList").css('display',"none");
            $("#monitorLeftPanel").hide();
            $(".map").removeClass("map").addClass("map-full");
            $(".btn-map-extent").addClass("fa-rotate-180");
        }
      
        updateMapSize();        
    }

    setTarckSummary(data,imei,dtm){
        console.log("setTarckSummary",data)
        setCurrentStatus(data.current_status,imei,dtm);
        this.setState({trackSummary : data[0]});
    }
    setUpdatePOI(isUpdatePOI){
        setUpdatePOI(isUpdatePOI)
    }
    setVisiblePOILayer(isVisible){
        setVisiblePOILayer(isVisible)
    }
    setVisiblePOIName(isVisible){
        setVisiblePOIName(isVisible)
    }
    refreshPOI(){
        getPOI();
    }
    zoomToLatLong(lat,long){
        zoomToExtent(lat,long);
    }
    handleSwitchBaseMap(e){
        switchBaseMap(!e.target.checked);
    }

    clearSelectCar(){
        clearSelectCar();
    }
    
    render() {
        let styleToggle={
            position: 'absolute',
            right: 7,
            top: 85,
            zIndex: 1,
            width: 60,
            cursor: 'pointer' 
        }
        let trafficToggle={
            position: 'absolute',
            right: 7,
            top: 155,
            zIndex: 1,
            width: 60,
            cursor: 'pointer' 
        }
       
        return (
            <div >
                <TarckSummary track = {this.state.trackSummary} />
                <div id="marker" style={{display:"none"}}></div>
                <img style={styleToggle}  src={this.state.mapTogglePath} className="img-thumbnail" onClick={this.handleSetMapToggle.bind(this)}/>
                <img style={trafficToggle}  src={this.state.trafficTogglePath} className="img-thumbnail" onClick={this.handleSetTrafficToggle.bind(this)}/>
                <div id="mapTracking" className="map" ref="map" >
                <i class="btn-map-extent fab fa-red-river hide-xs show-sm" onClick={this.handleFullScreenToggle.bind(this)}></i>
                    <div className="pull-right" style={{bottom:0,right:0,position:"absolute",zIndex:1,fontWeight:"bold"}}>
                        <span style={{position:"relative"}}>Google Map</span>
                        <label className="switch">
                            <input type="checkbox" onChange={this.handleSwitchBaseMap.bind(this)} defaultChecked={true}/>
                            <span className="slider"></span>
                            
                        </label>
                        <span style={{position:"relative"}}>Longdo Map</span>
                    </div>
                </div>
                <div id="mapTrackingPopup" class="ol-popup">
                    <a href="#" id="mapTrackingPopupCloser" className="ol-popup-closer" ></a>
                    <div id="mapTrackingPopupContent">
                        <MapBalloon />
                    </div>
                </div>
                
            </div>
        )
    }
}
// export default withNamespaces('Monitor')(MapTracking);
export default MapTracking;



// WEBPACK FOOTER //
// ./src/app/view/components/Monitor/MapTracking/MapTracking.js